import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import highValueImg from "../../../../assets/imgs/services/nationals/high-value.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import highValue1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg"
import highValue2Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier1.svg"
import highValue3Icon from "../../../../assets/imgs/services/nationals/highvalue-icons/highvalue3.svg"
import NationalDescription from "../../../../components/national-description/national-description";

function HighValue() {
  const [tHighValue] = useTranslation("highValuePage");
  const [tSMetaData] = useTranslation("metaData");
  const idHighValue = "c25cf9ca-9fcf-4b25-8db0-a9e7bb2bed53";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[4]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[4]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHighValue}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Embalaje y Manejo Especial"]
              .content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Packaging and Special Handling"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("altoValor.title")}</title>
        <meta
          name="description"
          content={tSMetaData("altoValor.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tHighValue("header.section")}
        title={tHighValue("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tHighValue("description.content"))
        }
        quoteBtn={tHighValue("header.quote-btn")}
        quoteProductID="btnQuoteValue"
        contactSales={tHighValue("header.contact-sales")}
        contactProductID="btnContactValue"
        imgBackground={highValueImg}
      /> */}
      <ImageHeader
        imgBackground={highValueImg}
      />

      {/* <Accordion
        title={tHighValue("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tHighValue("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHighValue("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tHighValue("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHighValue("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tHighValue("accordion-3.content"))
        }
      /> */}
      <div className="info-national-content">
        <NationalDescription
          title={tHighValue("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tHighValue("header.quote-btn")}
          quoteProductID="btnQuoteGold"
          contactSales={tHighValue("header.contact-sales")}
          contactProductID="btnContactGold"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tHighValue("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tHighValue("accordion-1.title")}
              content={
                accordion1
                  ? JSON.parse(accordion1) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tHighValue("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tHighValue("accordion-3.title")}
              content={
                accordion3
                  ? JSON.parse(accordion3) : "{}"
              }
            />
          </div>
          
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tHighValue("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={highValue1Icon} /></div>
              <p>{tHighValue("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={highValue2Icon} /></div>
              <p>{tHighValue("non-applicable-charges.item2")}</p>
            </div>

          </div>
        </div>

        <div className="more-info-box">
          <h5>{tHighValue("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={highValue3Icon} /></div>
              <p>{tHighValue("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={highValue3Icon} /></div>
              <p>{tHighValue("additional-conditions.item2")}</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default HighValue;
